export default __webpack_public_path__ + "static/media/rewards_poster_sample.6515ee96.png";